import { customSpringAxios } from "./axios";
import { dedupeTrips } from "./trips";

// Isti podaci kao stari POST /boughtTicket, ali dvokorakim putem u Javi:
// stari poziv materijalizuje ceo v_ticket pa traje sekundama po korisniku.
export const getAllByPassengerUID = async (passengerUID) => {
    const response = await customSpringAxios.get("/ticket/mine", {
        params: { uid: passengerUID },
    });
    return response.data;
};

export const postTicketReservationAPI = async (data) => {
    const response = await customSpringAxios.post("/ticket/reservation", data);
    return response.data;
};

export const postTicketReleaseAPI = async (data) => {
    const response = await customSpringAxios.post("/ticket/reservation/cancel", data);
    return response.data;
};

export const cancelTicketReservationByIds = async (ids) => {
    if (ids && ids.length > 0) {
        const response = await customSpringAxios.post("/ticket/reservation/cancel", ids);
        return response.data;
    }
};

export const updateTicketReservationAPI = async (data) => {
    const response = await customSpringAxios.post("/ticket/reservation/change-seat", data);
    return response.data;
};

export const handleDownloadApi = async (id) => {
    return customSpringAxios.get(`/ticket/${id}/download`, {
        params: { online: true },
        responseType: 'blob',
    });
};

export const getPassengerTicketsByUidAPI = async (uid) => {
    const response = await customSpringAxios.get(`/ticket/passenger/${uid}`);
    return response.data;
};

export const getTicketByTicketIdAPI = async (id) => {
    const response = await customSpringAxios.get(`/ticket/${id}`);
    return response.data;
};

// Overa povratne karte — dostupni povratni polasci (server zna stanice/prevoznika sa karte).
export const getReturnAvailableTripsAPI = async (ticketId, date) => {
    const response = await customSpringAxios.get(`/return-ticket/${ticketId}/available-trips`, {
        params: { date },
    });
    return dedupeTrips(response.data);
};

// Overa povratne karte — popunjava trip/datum/sediste i zauzima alotman.
export const verifyReturnTicketAPI = async (ticketId, data) => {
    const response = await customSpringAxios.post(`/return-ticket/${ticketId}/verify`, data);
    return response.data;
};

// „Podseti me kasnije" za overu povratne — server pomeri sledeći podsetnik.
export const remindLaterReturnTicketAPI = async (ticketId) => {
    const response = await customSpringAxios.post(`/return-ticket/${ticketId}/remind-later`);
    return response.data;
};

// Zamena polaska jednosmerne karte — polasci ISTE linije za dati datum,
// sa slobodnim mestom i istom cenom (server sve proverava, uklj. vlasništvo).
export const getExchangeAvailableTripsAPI = async (ticketId, date) => {
    const response = await customSpringAxios.get(`/ticket/${ticketId}/exchange/available-trips`, {
        params: { date },
    });
    return dedupeTrips(response.data);
};

// Zamena polaska — premesti kartu na izabrani polazak (jednom, do 2h pre polaska).
export const exchangeTicketAPI = async (ticketId, data) => {
    const response = await customSpringAxios.post(`/ticket/${ticketId}/exchange`, data);
    return response.data;
};

// Digitalna kopija karte — javni pregled po claim tokenu (stranica /k/{token});
// token je nasumičan, pa lookup ne traži prijavu.
export const getTicketByClaimTokenAPI = async (token) => {
    const response = await customSpringAxios.get(`/ticket-claim/${token}`);
    return response.data;
};

export const downloadClaimPdfApi = async (token) => {
    return customSpringAxios.get(`/ticket-claim/${token}/pdf`, {
        responseType: 'blob',
    });
};

// Vezivanje karte za prijavljeni BusGo nalog (identitet ide kroz CF proxy).
export const claimTicketAPI = async (token) => {
    const response = await customSpringAxios.post(`/ticket-claim/${token}/claim`);
    return response.data;
};

export const getTicketByPassengerUIDAPI = async (data) => {
    const { passengerUID, cancelled, page, size } = data;
    const response = await customSpringAxios.get(
        `/ticket/getAllTicketsByPassengerUid?uid=${passengerUID}&cancelled=${cancelled}&page=${page}&size=${size}`
    );
    return response.data;
};
